import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
// import { Progress, Tag } from "antd";
import { Ui } from "../../services";
import Api from "../../services/ServiceApi";
import Cookies from "js-cookie";
class TeamManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Team Management",
      tab: [
        // { text: "Progress Task" },
        { text: "All Employee" },
        { text: "All Team" },
      ],
      active: 1,
      data: [1, 2, 3, 4],
      employee_list: [],
      employee_count: 0,
      team_count: 0,
      team_list: [],
      isTeamListReturned: false,
    };

    this.headerHandler = this.headerHandler.bind(this);
  }

  async componentDidMount() {
    document.title = this.state.title;
     await Api.post("get_team_management_team_list", {
      //company_id:1,
      company_id: Cookies.get("companyid"),
      is_active: 1,
    }).then((val) => {
      console.log(val.data.data);
      let result = val.data.data;
      this.setState({
        team_count: result.table.length,
        team_list: result,
        isTeamListReturned: true,
      });
    });
  }

  headerHandler(value, type) {
    if (type === 1) {
      //employee
      this.setState({
        employee_count: value,
      });
    } else {
      this.setState({
        team_count: value,
      });
    }
  }

  render() {
    const { title, active, tab, isTeamListReturned } = this.state;
    console.log("state", this.state);
    return (
      <LayoutOperation active={5}>
        <div className="noselect wrapper-header d-flex align-items-center">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-3">
                <img
                  src={Api.absoluteUrl("/icon/team_management_white.svg")}
                  className="mr-3"
                  alt=""
                />
                <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b fs-20">
                  {title}
                </h2>
              </div>
              <div className="col-6">
                <div className="row justify-content-center">
                  <div className="col-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-thai-b c-white fs-14">
                        Total Team
                      </span>
                      <div className="stat d-flex align-items-center">
                        <span
                          className="font-thai-b fs-30 c-white w-100 text-center"
                          style={{ marginTop: "-5px" }}
                        >
                          {this.state.team_count}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-3 offset-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="font-thai-b c-white fs-14">
                        Total Employee
                      </span>
                      <div className="stat d-flex align-items-center">
                        <span
                          className="font-thai-b fs-30 c-white w-100 text-center"
                          style={{ marginTop: "-5px" }}
                        >
                          {this.state.employee_count}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3 text-right">
                <a href="/MaxiOperation/" className="c-white font-mont-m fs-12">
                  <img
                    src={Api.absoluteUrl("/icon/map.svg")}
                    className="mr-1"
                    alt=""
                  />
                  Map
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-body">
          <div className="container-fluid">
            <div className="card-table-ma">
              <ul className="nav">
                {tab.map((item, index) => (
                  <li key={index} className="nav-item fs-12 font-mont-sb mr-1">
                    <a
                      className={
                        active === index ? "nav-link active" : "nav-link"
                      }
                      onClick={() => this.setState({ active: index })}
                    >
                      {item.text}
                    </a>
                  </li>
                ))}
              </ul>
              {/* {(active === 0) ? <Ui.ProgressTask data={data}/> : null} */}
              {active === 0 ? (
                <Ui.AllEmployee headerHandler={this.headerHandler} />
              ) : null}
              {active === 1 && isTeamListReturned ? (
                <Ui.AllTeam
                  team_list={this.state.team_list.table}
                  selected_team={this.state.team_list.table[0].team_id}
                />
              ) : null}
            </div>
          </div>
        </div>
      </LayoutOperation>
    );
  }
}

export default TeamManagement;
